// Conteggio accanto a una voce di tendina: numero grigio chiaro con il separatore delle migliaia,
// come nei chip filtro del design system (niente pillola piena).
function fmtCount(count: number, language: string): string {
  return new Intl.NumberFormat(language, { useGrouping: 'always' } as Intl.NumberFormatOptions).format(count);
}

export function CountPill({
  count,
  active,
  language,
}: {
  count?: number;
  active: boolean;
  language: string;
}) {
  if (count == null) return null;
  return (
    <span className={`flex-shrink-0 text-[13px] tabular-nums ${active ? "text-brand-400" : "text-ink-muted/70"}`}>
      {fmtCount(count, language)}
    </span>
  );
}
